module.exports = __webpack_public_path__ + "mp.svg?e6ef4c392050cac6e1ebf70a2018d678";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mp.svg
// module id = 882
// module chunks = 27